const ScreenURL = {
  /** auth */
  LOGIN: "/sign-in",
  /** manage */
  MANAGE_CLIENT: "/manage-client",
  MANAGE_WORKSPACE: "/manage-workspace",
  MANAGE_ORGANIZATION: "/manage-organization",
  MANAGE_ORGANIZATION_ADMIN: "/manage-organization-admin",
  MANAGE_INSTITUTION: "/manage-institution",
  MANAGE_INSTITUTION_CREATE: "/manage-institution/create",
  /** configuration */
  WORKSPACE_CREATE: "/workspace/create",
  WORKSPACE_EDIT: "/workspace/edit/:workspace_id",

  ORGANIZATION_CREATE: "/organization/create",
  ORGANIZATION_EDIT: "/organization/edit/:organization_id",
  /** notice */
  NOTICE: "/notice",
  NOTICE_WRITE: "/notice/write",
  NOTICE_EDIT: "/notice/:notice_id/write",
  NOTICE_DETAIL: "/notice/:notice_id/detail",
  /** log */
  /** @deprecated */
  ACCESS: "/access",
  /** @deprecated */
  DASHBOARD: "/dashboard",
  /** @deprecated */
  REPORT_USER_LOG: "/users",
  /** payment */
  CREATE_PAYMENT_WINDOW: "/credit",
  PAYMENT_WINDOW_CREATION_HISTORY: "/payment-history",
  /** oauth */
  MANAGE_OAUTH_CLIENT: "/manage-oauth-client",
};

export default ScreenURL;
